import TotalRecord from '../totalRecord'
import {
  StyleDisplay,
  StyleSelect,
  StyledTableFooterContainer
} from './FooterTable.styled'
import { Col, Pagination, Row } from 'antd'
import {
  DEFAULT_CURRENT_PAGE,
  PAGE_SIZE_OPTIONS,
  PAGE_SIZE_OPTION_ALL
} from 'constants/common'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  querySearchSelector,
  setOffsetLimitAction
} from 'store/searchQuerySlice'

interface FooterTableProps {
  forPage?: string
  pageSize?: number
  defaultCurrentPage?: number
  pageSizeOptions?: any
  totalRecord?: number
  showOptionAll?: boolean
  onChangePageSize?: (value: number) => void
  onChangePage?: (value: number) => void
  onSearch?: (data: { offset: number; limit: number }) => void
  [key: string]: any
  onPaginatedDataChange?: (data: any[]) => void
}

const FooterTable: FC<FooterTableProps> = ({
  forPage = '',
  pageSize,
  defaultCurrentPage = DEFAULT_CURRENT_PAGE,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
  totalRecord,
  showOptionAll,
  onChangePageSize,
  onChangePage,
  onSearch,
  ...props
}) => {
  const dispatch = useDispatch()
  const query = useSelector(querySearchSelector)[forPage]
  const { t } = useTranslation()
  const handleOnchangePageSize = (value: number) => {
    dispatch(
      setOffsetLimitAction({
        field: forPage,
        offset: 0,
        limit: value
      })
    )
    if (onChangePageSize) onChangePageSize(value)
    if (onSearch)
      onSearch({
        offset: 0,
        limit: value
      })
  }

  const handleOnChangePage = (value: number) => {
    dispatch(
      setOffsetLimitAction({
        field: forPage,
        offset: (value - 1) * (query?.limit || 50),
        limit: query?.limit || 50
      })
    )
    if (onChangePage) onChangePage(value)
    if (onSearch)
      onSearch({
        offset: (value - 1) * (query?.limit || 50),
        limit: query?.limit || 50
      })
  }

  const currentPage = (query?.offset || 0) / (query?.limit || 50) + 1

  useEffect(() => {
    if (showOptionAll) {
      pageSizeOptions
        .filter((op: any) => op.label === PAGE_SIZE_OPTION_ALL.label)
        .push(PAGE_SIZE_OPTION_ALL)
    }
  }, [showOptionAll])

  if (showOptionAll) {
    pageSizeOptions = pageSizeOptions.filter(
      (op: any) => op.label !== PAGE_SIZE_OPTION_ALL.label
    )
    if (showOptionAll) {
      pageSizeOptions.push({
        ...PAGE_SIZE_OPTION_ALL,
        label: t(PAGE_SIZE_OPTION_ALL.label)
      })
    }
  }
  return (
    <StyledTableFooterContainer>
      <Row justify="space-between">
        <Col>
          <StyleDisplay>{t('display')}</StyleDisplay>
          <StyleSelect
            options={pageSizeOptions}
            defaultValue={query?.limit || 50}
            size="small"
            onSelect={handleOnchangePageSize}
          />
        </Col>
        <Col>
          <Pagination
            showQuickJumper
            showTotal={() => <TotalRecord totalRecord={totalRecord} />}
            locale={{ jump_to: t('go-to'), page: t('page') }}
            defaultCurrent={currentPage || 1}
            current={currentPage || 1}
            total={totalRecord || 0}
            showSizeChanger={false}
            pageSize={query?.limit || 50}
            onChange={handleOnChangePage}
            {...props}
          />
        </Col>
      </Row>
    </StyledTableFooterContainer>
  )
}

export default FooterTable
